import { render, staticRenderFns } from "./PendingTasks.vue?vue&type=template&id=0ef32348&scoped=true"
import script from "./PendingTasks.vue?vue&type=script&lang=ts"
export * from "./PendingTasks.vue?vue&type=script&lang=ts"
import style0 from "./PendingTasks.vue?vue&type=style&index=0&id=0ef32348&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef32348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef32348')) {
      api.createRecord('0ef32348', component.options)
    } else {
      api.reload('0ef32348', component.options)
    }
    module.hot.accept("./PendingTasks.vue?vue&type=template&id=0ef32348&scoped=true", function () {
      api.rerender('0ef32348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/PendingTasks.vue"
export default component.exports